<template>
  <div v-on:click.self="closeModal" class="modal--wrapper" :class="{'modal-open': modalOpenState}">
    <div class="modal address-modal">
      <div class="modal--title">
        <div class="modal--title-text" v-if="action === 'create'">{{$t('profile.addresses.modal.title')}}</div>
        <div class="modal--title-text" v-if="action === 'update'">{{$t('profile.addresses.modal.u-title')}}</div>
        <div class="modal--title-actions">
          <modal-close-btn @click="closeModal" />
        </div>
      </div>
      <div class="modal--content" v-if="!loading">
        <template v-if="errs.length > 0">
          <div class="error-message" v-for="(item, index) in errs" :key="index+item.field" :item="item" :index="index">
            <p v-if="item.error === 'empty'">{{$t('profile.addresses.err.empty', item.field)}}</p>
          </div>
        </template>
        <div class="fields">
          <text-input name="description" :placeholder="$t('profile.addresses.modal.name')" v-model="form.description"/>
        </div>
        <div class="fields">
          <text-input name="description" :placeholder="$t('profile.addresses.modal.society_name')" v-model="form.society_name"/>
        </div>
        <div class="fields">
          <text-input name="address" :placeholder="$t('profile.addresses.modal.address')" v-model="form.address"/>
        </div>
        <div class="fields">
          <text-input name="additonal" :placeholder="$t('profile.addresses.modal.additional')" v-model="form.additional" />
        </div>
        <div class="fields field-inline">
          <text-input name="zipCode" :placeholder="$t('profile.addresses.modal.zip')" v-model="form.zip" />
          <text-input name="city" :placeholder="$t('profile.addresses.modal.city')" v-model="form.city" />
        </div>
        <div class="fields">
          <v-select
            :options="countries.map(c => ({id: c.id, text: c.name}))"
            :settings="{placeholder: $t('profile.addresses.modal.country')}"
            v-model="form.country_id"
          />
        </div>
        <div class="fields">
          <checkbox-input name="is_main" :label="$t('profile.addresses.modal.is_default')" :default-checked="form.is_main" v-model="form.is_main"/>
        </div>
      </div>
      <div class="modal--content" v-if="loading">
        <div class="loader">
          <loader/>
        </div>
      </div>
      <div class="modal--footer" v-if="!loading">
        <button class="btn btn-primary btn-std modal-btn" @click="create" v-if="action === 'create'">{{$t('profile.addresses.modal.add')}}</button>
        <button class="btn btn-primary btn-std modal-btn" @click="update" v-if="action === 'update'">{{$t('profile.addresses.modal.update')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
  import TextInput from '../../../components/text-input';
  import CheckboxInput from '../../../components/checkbox-input';
  import Loader from '../../../components/loader.component';
  import { mapState } from 'vuex';
  import ModalCloseBtn from "../../../components/modal-close-btn";

  export default {
    name: 'addresses-modal',
    components: {ModalCloseBtn, Loader, CheckboxInput, TextInput },
    computed: {
      errs () {
        return this.errors.concat(this.apiErrors);
      },
      ...mapState({
        loading: s => s.clientAddresses.loading || s.countries.loading,
        countries: s => s.countries.countries,
        addresses: s => s.clientAddresses.addresses.sort((a, b) => (a.is_main < b.is_main ? 1 : -1)),
        addressId: s => s.addressesModal.addressId,
        apiErrors: s => s.addressesModal.parsedErrors
      }),
    },
    data() {
      return {
        modalOpenState: false,
        action: '',
        errors: [],
        form: {
          address_id: null,
          society_name: '',
          address: '',
          additional: '',
          zip: '',
          city: '',
          country_id: null,
          description: '',
          is_main: true,
        },
      };
    },
    methods: {
      closeModal() {
        this.modalOpenState = false;
        this.form = {
          address_id: null,
          address: '',
          additional: '',
          zip: '',
          city: '',
          country_id: null,
          description: '',
          is_main: true,
        };
      },
      openModal(id = null) {
        id = this.addressId;
        this.action = id ? 'update' : 'create';
        if (this.action === 'update') {
          const address = this.addresses.filter(a => a.id === id);
          if (address.length === 0) {
            return;
          }
          this.form = {
            address_id: id,
            address: address[0].address,
            society_name: address[0].society_name,
            additional: address[0].additional,
            zip: address[0].zip,
            city: address[0].city,
            country_id: address[0].country.id,
            description: address[0].description,
            is_main: address[0].is_main,
          };
          this.$forceUpdate();
        }
        this.$nextTick(() => {
          this.modalOpenState = true;
        });
      },
      checkForm () {
        this.errors = [];
        if (!this.form.description || this.form.description.length === 0) {
          this.errors.push({field: this.$t('profile.addresses.modal.name'), error: 'empty'});
        }
        if (!this.form.address || this.form.address.length === 0) {
          this.errors.push({field: this.$t('profile.addresses.modal.address'), error: 'empty'});
        }
        if (!this.form.zip || this.form.zip.length === 0) {
          this.errors.push({field: this.$t('profile.addresses.modal.zip'), error: 'empty'});
        }
        if (!this.form.city || this.form.city.length === 0) {
          this.errors.push({field: this.$t('profile.addresses.modal.city'), error: 'empty'});
        }
        if (!this.form.country_id || this.form.country_id.length === 0) {
          this.errors.push({field: this.$t('profile.addresses.modal.country'), error: 'empty'});
        }
        return this.errors.length === 0;
      },
      async create() {
        if (!this.checkForm()) return;
        await this.$store.dispatch('clientAddresses/create', this.form);
        this.modalOpenState = false;
      },
      async update() {
        await this.$store.dispatch('clientAddresses/update', this.form);
        this.modalOpenState = false;
      },
    },
    async mounted() {
      await this.$store.dispatch('clientAddresses/fetch');
      await this.$store.dispatch('countries/init');
      await window.addEventListener('app:addresses-modal.open', () => {
        this.openModal();
      });
    },
  };
</script>

<style scoped>
  .address-actions {
    display: flex;
    flex-wrap: wrap;
    background: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    position: relative;
    margin-top: -8px;
    padding-top: 8px;
    min-height: 40px;
    z-index: 1;
  }
  .address-container {
    margin-bottom: 1rem;
  }
  .address-actions .btn {
    display: block;
    flex: 0 0 auto;
    margin: -8px 0 0 auto;
    padding-top: 16px;
  }
  .address-actions .btn:not(:first-child) {
    margin: -8px 0 0 0;
    padding-top: 16px;
  }

  .address-main {
    font-weight: 500;
    font-size: 1.2em;
    line-height: 32px;
  }
  .address-flex-left {
    background: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    padding: 1rem;
    position: relative;
    min-height: 32px;
    z-index: 2;
  }
  .address-container.main-address .address-flex-left {
    background: linear-gradient(217deg, #d65c46, #c15842 100%);
    color: #fff;
  }
  .address-container:not(.main-address) .address-actions {
    background: #c15842;
    color: #fff;
  }
  .address-container:not(.main-address) .address-actions .btn-secondary {
    color: #fff;
  }
  .address-container:not(.main-address) .address-actions .btn-secondary:hover {
    color: #c15842;
    background: #fff;
  }
  .address-container.main-address .address-flex-left .address-main {
    color: #fff;
  }
  .address-flex-left div:not(.address-main) {
    font-size: .9em;
    opacity: .8;
  }
  .address-container.main-address .address-flex-left div:not(.address-main) {
    opacity: .9;
  }

  .fields {
    margin: 0 0 10px 0;
  }
  .field-inline {
    display: grid;
    grid-gap: 1rem;
    grid-template: "1fr 1fr";
  }
  .c-loading {
    display: flex;
  }
  .loader {
    flex: 0 0 auto;
    width: 120px;
    margin: auto;
  }

  @media only screen and (max-width: 768px) {
    .modal--title-actions {
      width: 100%;
      bottom: unset;
      position: absolute;
      top: -6px;
    }
    .modal--title-text {
      width: calc(100% - 45px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/client/part/addresses-modal.vue